<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-03-25 09:38:23
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-06-19 17:04:48
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-website/src/components/homeFooter.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="homeFooter">
    <div class="footer-container">
      <ul>
        <li>版权©️海南会多多信息技术有限公司</li>
        <li> <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/recordQuery">琼ICP备2021004082号-1</a></li>
        <!-- <li>公司地址：海南省海口市龙华区南沙路47号通信广场二K007</li> -->
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'homeFooter',
  props: {},
  components: {},
  data() {
    return {}
  },
  methods: {},
  mounted() { }
}
</script>
<style scoped lang="less">
.homeFooter {
  font-size: 16px;
  margin-top: auto;
}
.footer-container {
  background: #23252B;
  height: 3.125em;
  display: flex;
  align-items: center;
}
.footer-container ul {
  width: fit-content;
  margin: 0 auto;
  display: flex;
  align-items: center;
  font-size: .75em;
  color: #9E9E9E;
  cursor: pointer;
  text-wrap: nowrap;
  
}

.footer-container ul li {
  display: inline-block;
  margin-right: 2.5rem;
  font-size: .75em;
}
.footer-container ul li a {
  font:inherit;
  color: #9e9e9e;
}
.footer-container ul li {
  display: inline-block;
  margin-right: 40px;
}
@media screen and (max-width: 768px) {
  .footer-container {
    height: 70px;
  }

  .footer-container ul {
    display: flex;
    flex-flow: column wrap;
    align-items: center;
    font-size: 12px;
  }

  .footer-container ul li {
    text-align: center;
    margin-top: 5px;
    margin-right: 0;
    font-size: 12px;
  }
  .footer-container ul li a {
  font-size:12px;
  color: #9e9e9e;
}
}

// 移动端结束


// 平板开始
@media screen and (min-width: 768px) and (max-width: 992px) {
  .homeFooter {
    font-size: 14px;
  }
}

// 平板结束

// 中等屏幕开始

@media screen and (min-width: 992px) and (max-width: 1200px) {
  .homeFooter {
    font-size: 18px !important;
  }
}

// 中等屏幕结束

// 大屏幕1200px - 1596px 开始
@media screen and (min-width: 1200px) and (max-width: 1596px) {
  .homeFooter {
    font-size: 20px!important;
  }
}

// 大屏幕1200px - 1596px 结束


// 大屏幕1596px 开始
@media screen and (min-width: 1596px) {
  .homeFooter {
    font-size: 24px!important;
  }
}

// 大屏幕1596px 结束</style>